<template>
  <nav
    class="fixed z-50 flex flex-wrap items-center justify-between w-full p-6 border-t-8 border-green-500"
    v-bind:class="{ 'bg-gray-700': open }"
  >
    <div class="mr-6 text-white">
      <a href="..">
        <svgLogo class="block h-8 text-green-500 fill-current lg:mx-0 sm:hidden" />
        <svgLogoHorizontal class="hidden h-8 text-green-500 fill-current lg:mx-0 sm:block" />
      </a>
    </div>
    <div class="block lg:hidden">
      <button
        v-on:click="toggle()"
        class="flex items-center px-3 py-2 text-green-500 border border-green-500 rounded"
      >
        <svg class="w-4 h-4 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <title>Menu</title>
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </button>
    </div>
    <div
      v-bind:class="open ? 'block': 'hidden'"
      class="flex-grow w-full h-screen pb-1/5 lg:pb-0 lg:h-auto lg:flex lg:w-auto"
    >
      <scrollactive
        class="flex flex-col h-full text-2xl font-bold tracking-widest text-center uppercase lg:ml-auto lg:flex-row lg:text-right lg:text-base font-raleway md:font-medium lg:items-center md:tracking-normal"
        :offset="90"
        :scrollOffset="70"
      >
        <div class="items-center">
          <a
            href="../#collier"
            v-on:click="open = false"
            class="block mt-16 mr-3 text-gray-200 lg:inline-block lg:mt-0 hover:text-white scrollactive-item"
          >Le collier</a>
          <a
            href="../#application"
            v-on:click="open = false"
            class="block mt-16 mr-3 text-gray-200 lg:inline-block lg:mt-0 hover:text-white scrollactive-item"
          >L’application</a>
            <!-- <a
              href="../#timeline"
              v-scroll-to="'#timeline'"
              v-on:click="open = false"
              class="block mt-16 mr-3 text-gray-200 lg:inline-block lg:mt-0 hover:text-white"
            >Notre histoire</a> -->
          <a href="../#storytelling" class="scrollactive-item"></a>
          <a
            href="../tech"
            v-on:click="open = false"
            class="block mt-16 mr-3 text-gray-200 lg:inline-block lg:mt-0 hover:text-white"
          >Tech</a>
        </div>
        <a
          href="../#soutenir"
          v-on:click="open = false"
          class="block px-4 py-3 mt-16 font-bold leading-none tracking-wider uppercase bg-green-500 rounded-full shadow-md lg:mt-0 lg:inline-block lg:text-sm hover:bg-green-400 hover:shadow-lg scrollactive-item"
          style="color: white!important"
        >Nous soutenir
        <!-- <Countdown
          class="hidden lg:inline-block"
          starttime="Mar 5, 2020 20:00:00"
          endtime="Apr 7, 2020 20:00:00"
          navbar
          trans='{  
          "day":"Jours",
          "hours":"Heures",
          "minutes":"Minutes",
          "seconds":"Seconds",
          "expired":"",
          "running":"Avant le début de la campagne.",
          "upcoming":"Till start of event.",
          "status": {
            "expired":"",
            "running":"",
            "upcoming":""
          }}'
          ></Countdown> -->
          </a>
      </scrollactive>
    </div>
  </nav>
</template>

<script>
import svgLogoHorizontal from "@/assets/svg/logoHorizontal.svg";
import svgLogo from "@/assets/svg/logo.svg";
import Countdown from "./Countdown";
export default {
  name: "Navbar",
  components: {
    svgLogoHorizontal,
    svgLogo,
    Countdown
  },
  data: function() {
    return {
      open: false
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>

<style scoped>

.is-active {
  @apply text-green-500 transition-colors duration-150;
}

</style>